const createBackgroundColor = () => ({
  parseDOM: [{ tag: "span" }],
  toDOM: (node) => {
    const color = node.attrs.backgroundColor || "#ffffff";
    const style = `background-color:${color}`;
    return ["span", { style }, 0];
  },
  attrs: {
    backgroundColor: { default: null },
  },
});

export default createBackgroundColor;
